import { useMemo } from 'react';
import '../../App.css';

const MAX_VALUE = 400;

interface RangeSliderProps {
  value: number;
  onChange: (value: number) => void;
}

const RangeSlider: React.FC<RangeSliderProps> = ({ value, onChange }) => {
  const percentage = useMemo(() => (value / MAX_VALUE) * 100, [value]);

  const sliderStyle = useMemo(() => ({
    background: `linear-gradient(to right, #e50aac ${percentage}%, #e0e0e0 ${percentage}%)`,
    width: '100%',
  }), [percentage]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = Number(event.target.value);
    onChange(newValue);
  };

  return (
    <div className="slider-container">
      <input
        type="range"
        min={1}
        max={MAX_VALUE}
        value={value}
        className="slider"
        onChange={handleChange}
        aria-label="Range slider"
        aria-valuenow={value}
        aria-valuemin={0}
        aria-valuemax={MAX_VALUE}
        style={sliderStyle}
      />
    </div>
  );
};

export default RangeSlider;
